import React, { useRef, useState, useEffect } from 'react';
import { Button, Popover, Overlay, Form, Badge } from 'react-bootstrap';

const FilterDropdown = ({ section, selectedValues = [], onApply }) => {
  const [open, setOpen] = useState(false);
  const [tempSelected, setTempSelected] = useState(selectedValues);
  const target = useRef(null);

  useEffect(() => {
    setTempSelected(selectedValues);
  }, [selectedValues]);

  const toggleItem = (val) => {
    setTempSelected((prev) =>
      prev.includes(val) ? prev.filter((v) => v !== val) : [...prev, val],
    );
  };

  const apply = () => {
    onApply(section.key, tempSelected);
    setOpen(false);
  };

  const clear = () => {
    setTempSelected([]);
  };

  return (
    <>
      <Button
        variant="outline-primary"
        size={'sm'}
        ref={target}
        onClick={() => setOpen(!open)}
      >
        {section.label}{' '}
        {tempSelected.length > 0 && (

          <>
            {'('}
            {tempSelected.length}
            {')'}
          </>
        )}
      </Button>

      <Overlay
        show={open}
        target={target.current}
        placement="bottom-start"
        rootClose
        onHide={() => setOpen(false)}
      >
        <Popover style={{ minWidth: '320px', maxWidth: '500px', width: '100%' }}>
          <Popover.Body>
            <div className="row gx-5 gy-4">
              {section.options.map((opt) => (
                <div key={opt.value} className="col-6">
                  <Form.Check
                    type="checkbox"
                    label={opt.label}
                    checked={tempSelected.includes(opt.value)}
                    onChange={() => toggleItem(opt.value)}
                    className="d-flex align-items-center gap-2 cursor-pointer"
                  >
                    <Form.Check.Input
                      type="checkbox"
                      checked={tempSelected.includes(opt.value)}
                      onChange={() => toggleItem(opt.value)}
                      style={{ transform: 'scale(1.3)' }}
                    />
                    <Form.Check.Label>{opt.label}</Form.Check.Label>
                  </Form.Check>
                </div>
              ))}
            </div>
            <div className="d-flex justify-content-between border-top pt-2 mt-2">
              <Button size="sm" variant="light" onClick={clear}>
                Wyczyść
              </Button>
              <Button size="sm" variant="primary" onClick={apply}>
                Zastosuj
              </Button>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
    </>
  );
};

export default FilterDropdown;
